import { FC } from 'react';
import { Skeleton } from 'ui/skeleton';
import { ContentDivider, ColumnTextBlock, SkeletonRow } from '../Styles';

export const CampaignSkeleton: FC = () => {
  return (
    <div data-test="brand-affinity-xai-campaign-skeleton">
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
      <ContentDivider />
      <SkeletonRow>
        <Skeleton height={50} width={60} />
        <ColumnTextBlock>
          <Skeleton height={20} width={200} />
          <Skeleton height={16} width={150} />
        </ColumnTextBlock>
      </SkeletonRow>
    </div>
  );
};
